import { ThemeUICSSObject } from '@apia/theme';
import main from './main';
import list from './list';
import toolbar from './toolbar';
/* IMPORT HERE */

const print: ThemeUICSSObject = {
  main,
  list,
  toolbar,
  /* PREPEND HERE */
};

export default print;
